export enum SubmissionsListFiltersFormFields {
  statuses = 'statuses',
  from = 'from',
  to = 'to',
  fastTrack = 'fastTrack',
  tasksStatuses = 'tasksStatuses',
  contentTypes = 'contentTypes',
}
